module.exports = __webpack_public_path__ + "static/media/auto_icon_pb.cb1a361c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auto_icon_pb.svg
// module id = 1209
// module chunks = 0